<template>
  <div class="google-auth">
    <div class="auth-divider">
      <span>{{ $t('auth.or_continue_with') }}</span>
    </div>
    <button type="button" class="btn btn-block btn-lg btn-google" :disabled="disabled" @click="startGoogle">
      <svg class="google-icon" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.56 2.95-2.23 5.45-4.76 7.14l7.73 6c4.51-4.16 7.09-10.27 7.09-17.65z"/>
        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
      </svg>
      <span>{{ $t('auth.continue_with_google') }}</span>
    </button>
  </div>
</template>

<script>
import { googleAuthURL } from '@/api/auth'

export default {
  props: {
    redirect: {
      type: String,
      default: '/dashboard',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    startGoogle() {
      window.location.assign(googleAuthURL(this.redirect))
    },
  },
}
</script>

<style scoped>
.auth-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 18px 0 14px;
  color: #94a3b8;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.auth-divider::before,
.auth-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: #e2e8f0;
}
.btn-google {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: #fff;
  border: 1px solid #dadce0;
  color: #3c4043;
  font-weight: 500;
}
.btn-google:hover:not(:disabled) {
  background: #f8f9fa;
  border-color: #c6c9cc;
  color: #202124;
}
.btn-google:disabled {
  opacity: 0.65;
}
.google-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
</style>
